module.exports = __webpack_public_path__ + "static/img/b.9b76a04.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jeu2/img/b.png
// module id = fvsO
// module chunks = 0